import { Button, makeStyles } from "@material-ui/core"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"

const useStyles = makeStyles(theme => ({
    botao: {
        color: "#5f5f5f",
    },
    listaIntegracoes: {
        backgroundColor: "#fff",
        position: "fixed",
        zIndex: 5,
    },
    itemLista: {
        height: "90px",
        justifyContent: "center",
        alignItems: "center",
    },
}))

export default function BotaoIntegracoes({ setExpandListaIntegracoes, expandListaIntegracoes }) {
    const classes = useStyles()

    return (
        <>
            <Button
                onClick={() => {
                    setExpandListaIntegracoes(!expandListaIntegracoes)
                }}
                size="small"
                className={classes.botao}
                id="botao-lista-integracoes"
            >
                <ExpandMoreIcon style={{ margin: "0 5px 0 0", fontSize: "28px" }} />
                <span className="none-mobile">Integrações</span>
            </Button>
        </>
    )
}
